import { NavLink } from "react-router-dom";
import { isDemoMode } from "../../services";
import { Radar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { useTheme } from '../../contexts/ThemeContext';
import ExportMenu from "../../components/ExportMenu";
import useBrandMetrics from "../../hooks/useBrandMetrics";
import { usePageInsights } from "../../hooks/usePageInsights";
import ActiveFilters from "../../components/ActiveFilters";
import AIInsightPanel from "../../components/AIInsightPanel";
import BrandEquityCard from "../../components/BrandEquityCard";
import { useFilters } from "../../contexts/FiltersContext";

// Register ChartJS components
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  ChartDataLabels
);


export default function ExecutiveDashboard() {
  const { isDark } = useTheme();
  const { selectedFilters } = useFilters()
  const { health, loading, error } = useBrandMetrics();
  const { insights: pageInsights, loading: pageInsightsLoading } = usePageInsights('executive');

  // Combined view data - Comprehensive brand health radar
  const combinedData = health?.traditional.metrics ? {
    labels: ['Awareness', 'Consideration', 'Usage', 'MOUB', 'Loyalty'],
    datasets: [{
      label: health?.traditional.name,
      data: [
        health?.traditional.metrics.awareness,
        health?.traditional.metrics.consideration,
        health?.traditional.metrics.usage,
        health?.traditional.metrics.primary_brand,
        health?.traditional.metrics.loyalty,
      ],
      backgroundColor: 'rgba(59, 130, 246, 0.2)',
      borderColor: 'rgba(59, 130, 246, 1)',
      pointBackgroundColor: 'rgba(59, 130, 246, 1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(59, 130, 246, 1)'
    }, {
      label: 'Competition Average',
      data: health ? [
        health.industry_averages.awareness || 0,
        health.industry_averages.consideration || 0,
        health.industry_averages.usage || 0,
        health.industry_averages.moub || 0,
        health.industry_averages.loyalty || 0
      ] : [0, 0, 0, 0, 0, 0, 0, 0],
      backgroundColor: 'rgba(156, 163, 175, 0.1)',
      borderColor: 'rgba(156, 163, 175, 0.5)',
      borderDash: [5, 5],
      pointBackgroundColor: 'rgba(156, 163, 175, 0.5)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(156, 163, 175, 0.5)'
    }]
  } : null;

  // const [insights, setInsights] = useState<string[]>([]);
  // const [insightsLoading, setInsightsLoading] = useState(false);

  // // Track if a fetch is in progress to prevent duplicate calls
  // const fetchInsightsRef = useRef<boolean>(false);

  // // Fetch insights only for executive tab to prevent unnecessary calls
  // useEffect(() => {
  //   if (selectedBrand && activeTab === 'executive') {
  //     fetchInsights(selectedBrand, activeTab);
  //   }
  // }, [selectedBrand, activeTab]);

  
  // const fetchInsights = async (brandId: string, tab: string) => {
  //   // Prevent duplicate calls
  //   if (fetchInsightsRef.current) {
  //     return;
  //   }

  //   fetchInsightsRef.current = true;
  //   setInsightsLoading(true);
  //   setInsights([]); // Clear previous insights to show loading state

  //   // Add minimum loading time for better UX
  //   const startTime = Date.now();

  //   try {
  //     let insightsData: string[] | null = null;

  //     if (isDemoMode) {
  //       // Mock insights data
  //       insightsData = [
  //         `Your brand shows strong performance with a total equity score of ${metrics?.metrics.overall.toFixed(1)}%.`,
  //         `Traditional metrics indicate high trust (${metrics?.metrics.trust.toFixed(0)}%) and quality perception (${metrics?.metrics.quality.toFixed(0)}%).`,
  //         `Digital sentiment is ${metrics?.digital?.sentiment_score.toFixed(0)}% positive with ${metrics?.digital?.mentions_count.toLocaleString()} total mentions.`,
  //         `NPS score of ${metrics?.metrics.nps} indicates strong customer loyalty and advocacy.`,
  //         `Awareness to consideration conversion rate suggests effective brand communication.`
  //       ];
  //     } else {
  //       // Call the LLM-powered insights endpoint
  //       const response = await axios.get(`/api/v3/metrics/brands/${brandId}/insights`);
  //       if (response.data && response.data.insights) {
  //         insightsData = response.data.insights;
  //       }
  //     }

  //     // Ensure minimum loading time of 500ms for visibility
  //     const elapsedTime = Date.now() - startTime;
  //     if (elapsedTime < 500) {
  //       await new Promise(resolve => setTimeout(resolve, 500 - elapsedTime));
  //     }

  //     if (insightsData) {
  //       setInsights(insightsData);
  //     } else {
  //       // Fallback to rule-based insights if API doesn't return expected format
  //       if (metrics) {
  //         const newInsights = generateInsights(metrics, healthIndex, tab);
  //         setInsights(newInsights);
  //       }
  //     }
  //   } catch (error) {
  //     console.error('Failed to fetch AI insights, using fallback:', error);
  //     // Fallback to rule-based insights
  //     if (metrics) {
  //       const newInsights = generateInsights(metrics, healthIndex, tab);
  //       setInsights(newInsights);
  //     }
  //   } finally {
  //     setInsightsLoading(false);
  //     fetchInsightsRef.current = false;
  //   }
  // };

  // const generateInsights = (metricsData: any, indexData: any, tab: string): string[] => {
  //   const insights: string[] = [];
    
  //   if (tab === 'combined' && metricsData) {
  //     // Awareness to consideration conversion
  //     const conversionRate = (metricsData.traditional.consideration / metricsData.traditional.awareness) * 100;
  //     insights.push(`Your awareness to consideration conversion rate is ${conversionRate.toFixed(1)}%, ${conversionRate > 70 ? 'exceeding' : 'below'} industry benchmarks.`);
      
  //     // Quality perception
  //     if (metricsData.traditional.quality > 50) {
  //       insights.push(`Quality perception at ${metricsData.traditional.quality.toFixed(1)}% demonstrates strong product confidence among consumers.`);
  //     }
      
  //     // NPS analysis
  //     const npsCategory = metricsData.traditional.nps > 50 ? 'Excellent' : metricsData.traditional.nps > 0 ? 'Good' : 'Needs Improvement';
  //     insights.push(`NPS score of ${metricsData.traditional.nps} (${npsCategory}) ${metricsData.traditional.nps > 0 ? 'indicates positive word-of-mouth potential' : 'suggests focus on customer satisfaction is needed'}.`);
      
  //     // Digital presence
  //     insights.push(`Digital engagement rate of ${metricsData.digital.engagement_rate.toFixed(1)}% with ${metricsData.digital.mentions_count.toLocaleString()} monthly mentions shows ${metricsData.digital.engagement_rate > 5 ? 'strong' : 'moderate'} social media traction.`);
      
  //     // Brand health index
  //     if (indexData) {
  //       insights.push(`Brand Health Index of ${indexData.health_index.toFixed(0)} places you in the ${indexData.percentile.toFixed(0)}th percentile, ${indexData.percentile > 75 ? 'leading' : indexData.percentile > 50 ? 'above average in' : 'trailing'} the category.`);
  //     }
      
  //     // Value perception
  //     const valueGap = metricsData.traditional.quality - metricsData.traditional.value;
  //     if (valueGap > 10) {
  //       insights.push(`Quality (${metricsData.traditional.quality.toFixed(1)}%) exceeds value perception (${metricsData.traditional.value.toFixed(1)}%) by ${valueGap.toFixed(1)}pp, suggesting pricing optimization opportunity.`);
  //     }
      
  //     // Loyalty drivers
  //     insights.push(`Primary brand selection at ${metricsData.traditional.primary_brand.toFixed(1)}% with ${metricsData.traditional.loyalty.toFixed(1)}% loyalty indicates ${metricsData.traditional.primary_brand > 30 ? 'strong market position' : 'growth opportunity in repeat purchase behavior'}.`);
  //   }
    
  //   return insights;
  // };

  // Additional metrics for comprehensive view
  const additionalMetricsData = health?.traditional.metrics ? {
    labels: ['Taste', 'Texture', 'Natural', 'Pride', /* 'Advocacy', */ 'Trust', 'Quality', 'Value', 'Innovation'],
    datasets: [{
      label: 'Product Attributes',
      data: [
        health.traditional.metrics.taste || 0,
        health.traditional.metrics.texture || 0,
        health.traditional.metrics.natural || 0,
        health.traditional.metrics.pride || 0,
        // metrics.metrics.advocacy || 0,
        health.traditional.metrics.trust,
        health.traditional.metrics.quality,
        health.traditional.metrics.value,
        health.traditional.metrics.innovation,
      ],
      backgroundColor: 'rgba(16, 185, 129, 0.2)',
      borderColor: 'rgba(16, 185, 129, 1)',
      pointBackgroundColor: 'rgba(16, 185, 129, 1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(16, 185, 129, 1)'
    }]
  } : null;

  // Theme-aware chart options (matching DeepDiveDashboard radar styles)
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          color: isDark ? '#E5E7EB' : '#374151'
        }
      },
      datalabels: {
        color: isDark ? '#E5E7EB' : '#374151',
        font: {
          weight: 'bold' as const,
          size: 10
        },
        formatter: (value: number) => `${value.toLocaleString('en-US', { maximumFractionDigits: 0 })}%`,
        anchor: 'end' as const,
        align: 'end' as const,
        offset: 4
      }
    },
    scales: {
      r: {
        grid: {
          color: isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
        },
        pointLabels: {
          color: isDark ? '#E5E7EB' : '#1F2937',
          font: {
            size: 11
          }
        },
        ticks: {
          display: false
        },
        suggestedMin: 0,
        suggestedMax: 100
      }
    }
  };

  if (!health || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="text-text-muted mt-4">Loading brand health data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <i className="fas fa-exclamation-triangle text-4xl text-red-400 mb-4"></i>
          <p className="text-text-muted">Error loading data: {error.message}</p>
        </div>
      </div>
    );
  }


  return (
    <div className="space-y-4">
      <ActiveFilters selectedFilters={selectedFilters} />

      {/* Combined Overview */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {/* Brand Equity & Health Index - First Card */}
        <BrandEquityCard
          metrics={health?.traditional}
          digitalMetrics={health?.digital}
          health={health}
          loading={loading}
        />

        {/* Traditional Summary */}
        <div className="bg-card rounded-2xl p-6 border border-[var(--border)]">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-xl font-semibold text-foreground">Traditional Health</h3>
            <i className="fas fa-clipboard-list text-green-400 text-2xl"></i>
          </div>
          {health.traditional.metrics? (
            <>
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-text-muted">Awareness</span>
              <span className="text-foreground font-semibold">{health.traditional.metrics.awareness.toLocaleString('en-US', { maximumFractionDigits: 0 })}%</span>
            </div>
            <div className="flex justify-between">
              <span className="text-text-muted">NPS Score</span>
              <span className="text-foreground font-semibold">{(health.traditional.metrics.nps || 0).toLocaleString('en-US', { maximumFractionDigits: 0 })}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-text-muted">Loyalty</span>
              <span className="text-foreground font-semibold">{health.traditional.metrics.loyalty.toLocaleString('en-US', { maximumFractionDigits: 0 })}%</span>
            </div>
            <div className="flex justify-between">
              <span className="text-text-muted">Traditional Brand Equity</span>
              <span className="text-foreground font-semibold">{((health.traditional.metrics.awareness + health.traditional.metrics.trust + health.traditional.metrics.quality + health.traditional.metrics.loyalty) / 4).toLocaleString('en-US', { maximumFractionDigits: 0 })}%</span>
            </div>
          </div>
          <NavLink to="/dashboard/deepdive" className="block mt-4 w-full py-2 bg-emerald-600 hover:bg-emerald-700 text-white font-medium rounded-lg transition-colors text-sm text-center">View Details</NavLink>
          </>
          ): (
            <div className="flex items-center justify-center h-32">
              <p className="text-text-muted">No Traditional data available for the current brand.</p>
            </div>
          )}
        </div>

        {/* Digital Summary */}
        <div className="bg-card rounded-2xl p-6 border border-[var(--border)]">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-xl font-semibold text-foreground">Digital Health</h3>
            <i className="fas fa-globe text-primary text-2xl"></i>
          </div>
          {health.digital? (
            <>
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-text-muted">Sentiment</span>
                <span className="text-foreground font-semibold">{health.digital.sentiment_score?.toLocaleString('en-US', { maximumFractionDigits: 0 }) || '0'}%</span>
              </div>
              <div className="flex justify-between">
                <span className="text-text-muted">Engagement</span>
                <span className="text-foreground font-semibold">{health.digital.engagement_rate?.toLocaleString('en-US', { maximumFractionDigits: 0 }) || '0'}%</span>
              </div>
              <div className="flex justify-between">
                <span className="text-text-muted">Mentions</span>
                <span className="text-foreground font-semibold">{health.digital.mentions_count?.toLocaleString('en-US', { maximumFractionDigits: 0 }) || '0'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-text-muted">Digital Brand Equity</span>
                <span className="text-foreground font-semibold">{health.equity.digital_equity.toLocaleString('en-US', { maximumFractionDigits: 0 })}%</span>
              </div>
            </div>
            <NavLink to="/dashboard/digital" className="block mt-4 w-full py-2 bg-cyan-600 hover:bg-cyan-700 text-white font-medium rounded-lg transition-colors text-sm text-center">View Details</NavLink>
            </>
          ): (
            <div className="flex items-center justify-center h-32">
              <p className="text-text-muted">No Digital data available for the current brand.</p>
            </div>
          )}
          </div>
      </div>

      {/* Comprehensive Metrics Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {/* Brand Health Radar */}
        {combinedData && (
          <div className="bg-card rounded-2xl p-6 border border-[var(--border)]">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-semibold text-foreground">Brand Health Overview</h3>
              <ExportMenu
                data={health.traditional}
                chartElementId="brand-health-radar"
                exportType="chart"
                filename={`${health.traditional.name.toLowerCase().replace(/\s+/g, '_')}_health_overview`}
              />
            </div>
            <div className="h-96" id="brand-health-radar">
              <Radar data={combinedData} options={chartOptions} />
            </div>
          </div>
        )}

        {/* Product Attributes Radar */}
        {additionalMetricsData && (
          <div className="bg-card rounded-2xl p-6 border border-[var(--border)]">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-semibold text-foreground">Product Attributes</h3>
              <ExportMenu
                data={health.traditional}
                chartElementId="product-attributes-radar"
                exportType="chart"
                filename={`${health.traditional.name.toLowerCase().replace(/\s+/g, '_')}_attributes`}
              />
            </div>
            <div className="h-96" id="product-attributes-radar">
              <Radar data={additionalMetricsData} options={chartOptions} />
            </div>
          </div>
        )}
      </div>

      {/* TODO: add back Brand Equity Trend Chart */}
      {/* selectedBrand && isDemoMode && (
        <div className="bg-card rounded-2xl p-6 border border-[var(--border)] relative overflow-hidden">
          {/* New Banner *}
          {isDemoMode && (<div
            className="absolute top-0 right-0 text-white text-sm font-bold px-4 py-1.5 rounded-bl-xl shadow-lg"
            style={{
              animation: 'flashColors 1s ease-in-out infinite',
              background: 'linear-gradient(90deg, #10b981, #facc15)'
            }}
          >
            ✨ NEW
          </div>)}
          <div className="flex items-center justify-between mb-4">
            <div>
              <h3 className="text-xl font-semibold text-foreground">Brand Equity Trend</h3>
              <p className="text-sm text-text-muted">Traditional vs Digital Equity over time</p>
            </div>
            <ExportMenu
              data={metrics}
              chartElementId="equity-trend-chart"
              exportType="chart"
              filename={`${metrics.name.toLowerCase().replace(/\s+/g, '_')}_equity_trend`}
            />
          </div>
          <div className="h-80" id="equity-trend-chart">
            <Line
              data={{
                labels: availableMonths.map(m => m.label.split(' ')[0]), // Jun, Jul, Aug, etc.
                datasets: [
                  {
                    label: 'Traditional Equity',
                    data: getBrandTrendData(selectedBrand).map(item =>
                      (item.data.metrics.awareness * 100 + item.data.metrics.trust * 100 +
                       item.data.metrics.quality * 100 + item.data.metrics.loyalty * 100) / 4
                    ),
                    borderColor: 'rgb(34, 197, 94)',
                    backgroundColor: 'rgba(34, 197, 94, 0.1)',
                    fill: true,
                    tension: 0.4,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                  },
                  {
                    label: 'Digital Equity',
                    data: getBrandTrendData(selectedBrand).map(item => item.data.digital.sentiment_score),
                    borderColor: 'rgb(6, 182, 212)',
                    backgroundColor: 'rgba(6, 182, 212, 0.1)',
                    fill: true,
                    tension: 0.4,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                  },
                  {
                    label: 'Total Brand Equity',
                    data: getBrandTrendData(selectedBrand).map(item =>
                      ((item.data.metrics.awareness * 100 + item.data.metrics.trust * 100 +
                        item.data.metrics.quality * 100 + item.data.metrics.loyalty * 100) / 4 * 0.6 +
                       item.data.digital.sentiment_score * 0.4)
                    ),
                    borderColor: 'rgb(168, 85, 247)',
                    backgroundColor: 'rgba(168, 85, 247, 0.1)',
                    fill: false,
                    tension: 0.4,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                    borderDash: [5, 5],
                  }
                ]
              }}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    position: 'top' as const,
                    labels: {
                      color: isDark ? '#E5E7EB' : '#374151',
                      usePointStyle: true,
                      pointStyle: 'circle',
                    }
                  },
                  tooltip: {
                    mode: 'index' as const,
                    intersect: false,
                    callbacks: {
                      label: function(context: any) {
                        return `${context.dataset.label}: ${context.parsed.y.toFixed(1)}%`;
                      }
                    }
                  }
                },
                scales: {
                  x: {
                    grid: {
                      color: isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
                    },
                    ticks: {
                      color: isDark ? '#9CA3AF' : '#4B5563',
                    }
                  },
                  y: {
                    min: 50,
                    max: 100,
                    grid: {
                      color: isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
                    },
                    ticks: {
                      color: isDark ? '#9CA3AF' : '#4B5563',
                      callback: function(value: any) {
                        return value + '%';
                      }
                    }
                  }
                },
                interaction: {
                  mode: 'nearest' as const,
                  axis: 'x' as const,
                  intersect: false
                }
              }}
            />
          </div>
        </div>
      ) */}

      {/* Detailed Metrics Cards */}
      {health.traditional.metrics && (<div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
        <div className="bg-card rounded-xl p-3 border border-[var(--border)]">
          <p className="text-xs text-text-muted">Taste</p>
          <p className="text-lg font-bold text-foreground">{(health.traditional.metrics.taste || 0).toLocaleString('en-US', { maximumFractionDigits: 0 })}%</p>
        </div>
        <div className="bg-card rounded-xl p-3 border border-[var(--border)]">
          <p className="text-xs text-text-muted">Texture</p>
          <p className="text-lg font-bold text-foreground">{(health.traditional.metrics.texture || 0).toLocaleString('en-US', { maximumFractionDigits: 0 })}%</p>
        </div>
        <div className="bg-card rounded-xl p-3 border border-[var(--border)]">
          <p className="text-xs text-text-muted">Natural</p>
          <p className="text-lg font-bold text-foreground">{(health.traditional.metrics.natural || 5).toLocaleString('en-US', { maximumFractionDigits: 0 })}%</p>
        </div>
        <div className="bg-card rounded-xl p-3 border border-[var(--border)]">
          <p className="text-xs text-text-muted">Recent Usage</p>
          <p className="text-lg font-bold text-foreground">{health.traditional.metrics.recent_usage.toLocaleString('en-US', { maximumFractionDigits: 0 })}%</p>
        </div>
        <div className="bg-card rounded-xl p-3 border border-[var(--border)]">
          <p className="text-xs text-text-muted">Primary Brand</p>
          <p className="text-lg font-bold text-foreground">{health.traditional.metrics.primary_brand.toLocaleString('en-US', { maximumFractionDigits: 0 })}%</p>
        </div>
        <div className="bg-card rounded-xl p-3 border border-[var(--border)]">
          <p className="text-xs text-text-muted">Responses</p>
          <p className="text-lg font-bold text-foreground">{health.traditional.respondent_count.toLocaleString('en-US', { maximumFractionDigits: 0 })}</p>
        </div>
      </div>)}

      <div className="grid grid-cols-2 gap-4">
          <style>{`
            @keyframes flashColors {
              0%, 100% { background: linear-gradient(90deg, #10b981, #22c55e); }
              50% { background: linear-gradient(90deg, #facc15, #eab308); }
            }
          `}</style>
          {/* Search Momentum Gauge */}
          <div className="bg-card rounded-2xl p-6 border border-border relative overflow-hidden">
            {isDemoMode && (<div
              className="absolute top-0 right-0 text-white text-sm font-bold px-4 py-1.5 rounded-bl-xl shadow-lg"
              style={{
                animation: 'flashColors 1s ease-in-out infinite',
                background: 'linear-gradient(90deg, #10b981, #facc15)'
              }}
            >
              ✨ NEW
            </div>)}
            <h3 className="text-xl font-semibold text-foreground mb-2">Share of Voice</h3>
            <p className="text-text-muted text-sm mb-6">Current month share of voice</p>
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-8">
              {/* Gauge */}
              <div className="flex flex-col items-center justify-center">
                <div className="relative w-64 h-64">
                  {/* Outer ring - background */}
                  <svg className="w-full h-full transform -rotate-90" viewBox="0 0 200 200">
                    {/* Background circle */}
                    <circle
                      cx="100"
                      cy="100"
                      r="80"
                      fill="none"
                      stroke={isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}
                      strokeWidth="16"
                    />
                    {/* Last month comparison (inner) */}
                    {/* <circle
                      cx="100"
                      cy="100"
                      r="65"
                      fill="none"
                      stroke={isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'}
                      strokeWidth="10"
                    />
                    <circle
                      cx="100"
                      cy="100"
                      r="65"
                      fill="none"
                      stroke="rgba(156, 163, 175, 0.5)"
                      strokeWidth="10"
                      strokeDasharray={`${((digitalMetrics.search_trends?.last_month_score || 0) / 100) * 408} 408`}
                      strokeLinecap="round"
                      className="transition-all duration-1000"
                    /> */}
                    {/* Current month progress (outer) */}
                    {health.digital && <circle
                      cx="100"
                      cy="100"
                      r="80"
                      fill="none"
                      stroke="url(#gaugeGradient)"
                      strokeWidth="16"
                      strokeDasharray={`${((health.digital.share_of_voice || 0) / 100) * 502} 502`}
                      strokeLinecap="round"
                      className="transition-all duration-1000"
                    />}
                    {/* Gradient definition */}
                    <defs>
                      <linearGradient id="gaugeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#3B82F6" />
                        <stop offset="50%" stopColor="#8B5CF6" />
                        <stop offset="100%" stopColor="#EC4899" />
                      </linearGradient>
                    </defs>
                  </svg>
                  {/* Center content */}
                  {!!health.digital ? (
                    <div className="absolute inset-0 flex flex-col items-center justify-center">
                      <span className="text-5xl font-bold text-foreground">{(health.digital.share_of_voice || 0).toFixed(0)}</span>
                      <span className="text-text-muted text-sm mt-1">out of 100</span>
                    </div>
                  ):(
                    <div className="absolute inset-0 flex flex-col items-center justify-center">
                      <span className="text-text-muted text-sm mt-1">No Data</span>
                    </div>
                  )}
                </div>
                {/* Legend */}
                <div className="flex gap-6 mt-4">
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500" />
                    <span className="text-sm text-text-muted">Share of Voice</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <style>{`
            @keyframes flashColors {
              0%, 100% { background: linear-gradient(90deg, #10b981, #22c55e); }
              50% { background: linear-gradient(90deg, #facc15, #eab308); }
            }
          `}</style>
          {/* Search Momentum Gauge */}
          <div className="bg-card rounded-2xl p-6 border border-border relative overflow-hidden">
            {isDemoMode && (<div
              className="absolute top-0 right-0 text-white text-sm font-bold px-4 py-1.5 rounded-bl-xl shadow-lg"
              style={{
                animation: 'flashColors 1s ease-in-out infinite',
                background: 'linear-gradient(90deg, #10b981, #facc15)'
              }}
            >
              ✨ NEW
            </div>)}
            <h3 className="text-xl font-semibold text-foreground mb-2">Search Momentum</h3>
            <p className="text-text-muted text-sm mb-6">Current month search performance score</p>
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-8">
              {/* Gauge */}
              <div className="flex flex-col items-center justify-center">
                <div className="relative w-64 h-64">
                  {/* Outer ring - background */}
                  <svg className="w-full h-full transform -rotate-90" viewBox="0 0 200 200">
                    {/* Background circle */}
                    <circle
                      cx="100"
                      cy="100"
                      r="80"
                      fill="none"
                      stroke={isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}
                      strokeWidth="16"
                    />
                    {/* Last month comparison (inner) */}
                    {/* <circle
                      cx="100"
                      cy="100"
                      r="65"
                      fill="none"
                      stroke={isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'}
                      strokeWidth="10"
                    />
                    <circle
                      cx="100"
                      cy="100"
                      r="65"
                      fill="none"
                      stroke="rgba(156, 163, 175, 0.5)"
                      strokeWidth="10"
                      strokeDasharray={`${((digitalMetrics.search_trends?.last_month_score || 0) / 100) * 408} 408`}
                      strokeLinecap="round"
                      className="transition-all duration-1000"
                    /> */}
                    {/* Current month progress (outer) */}
                    {health.digital && <circle
                      cx="100"
                      cy="100"
                      r="80"
                      fill="none"
                      stroke="url(#gaugeGradient)"
                      strokeWidth="16"
                      strokeDasharray={`${((health.digital.search_trends?.search_interest_score || 0) / 100) * 502} 502`}
                      strokeLinecap="round"
                      className="transition-all duration-1000"
                    />}
                    {/* Gradient definition */}
                    <defs>
                      <linearGradient id="gaugeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#3B82F6" />
                        <stop offset="50%" stopColor="#8B5CF6" />
                        <stop offset="100%" stopColor="#EC4899" />
                      </linearGradient>
                    </defs>
                  </svg>
                  {/* Center content */}
                  {health.digital ? (
                    <div className="absolute inset-0 flex flex-col items-center justify-center">
                      <span className="text-5xl font-bold text-foreground">{(health.digital.search_trends?.search_interest_score || 0).toFixed(0)}</span>
                      <span className="text-text-muted text-sm mt-1">out of 100</span>
                    </div>
                  ):(
                    <div className="absolute inset-0 flex flex-col items-center justify-center">
                      <span className="text-text-muted text-sm mt-1">No Data</span>
                    </div>
                  )}
                </div>
                {/* Legend */}
                <div className="flex gap-6 mt-4">
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500" />
                    <span className="text-sm text-text-muted">This Month</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      <AIInsightPanel title="AI-Generated Insights" insights={pageInsights} loading={pageInsightsLoading} />
    </div>
  )
}
